import { createSlice } from "@reduxjs/toolkit";
import { resendOtp } from "../../reducer/sendOtp/resendOtpReducer";

import i18n from "../../i18n";
const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const resendOtpSlice = createSlice({
  name: "resendOtp",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resendOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload; // consistency
        state.error = null;
      })
      .addCase(resendOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || i18n.t("toast.resendOtpFailed");
      });
  },
});

export default resendOtpSlice.reducer;
